import { render, staticRenderFns } from "./SektorAnalyzer.vue?vue&type=template&id=7188bd39&scoped=true&"
import script from "./SektorAnalyzer.vue?vue&type=script&lang=js&"
export * from "./SektorAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7188bd39",
  null
  
)

export default component.exports